import { apiClient } from '@/shared/api';
import type { SearchQueryRequest } from './types/request';
import type { SearchResult } from './types';

/**
 * Generic search using POST /search/query.
 * Supports NL (dslHuman) or DSL predicate search combined with filters.
 */
export const search = async <T>(request: SearchQueryRequest): Promise<SearchResult<T>> => {
  const { data } = await apiClient.post<SearchResult<T>>('/search/query', request);
  return data;
};
